// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_da-a";
export var fulfillmentFormRail = "_da-9";
export var headerTitleRow = "_da-c";
export var orderDetailsWrapper = "_da-7";
export var orderLinkTrigger = "_da-2";
export var paymentInformationGrid = "_da-h";
export var paymentSummaryColumn = "_da-i";
export var shipmentContainer = "_da-b";
export var shipmentDetailsMainPane = "_da-8";
export var shipmentNavigationCard = "_da-5";
export var shipmentNavigationRail = "_da-3";
export var shipmentNavigationRailHeader = "_da-4";
export var shipmentSummaryFact = "_da-e";
export var shipmentSummaryGrid = "_da-d";
export var shipmentSummaryMetadataRow = "_da-f";
export var shipmentSummaryTags = "_da-g";
export var shipmentWorkspace = "_da-0";
export var shipmentWorkspaceContent = "_da-6";
export var shipmentWorkspaceHeader = "_da-1";